// extracted by mini-css-extract-plugin
export var avatarContainer = "_9c-0";
export var avatarTypingWave = "_9c-i";
export var gray = "_9c-f";
export var green = "_9c-c";
export var icon = "_9c-9";
export var image = "_9c-1";
export var lg = "_9c-6";
export var md = "_9c-5";
export var presenceDot = "_9c-b";
export var red = "_9c-d";
export var sm = "_9c-4";
export var status = "_9c-a";
export var typingDot = "_9c-h";
export var typingPill = "_9c-g";
export var xl = "_9c-7";
export var xs = "_9c-3";
export var xxl = "_9c-8";
export var xxs = "_9c-2";
export var yellow = "_9c-e";